import e from "./WithBreadcrumb.vue_vue_type_script_setup_true_lang.js";
//#region src/schema/components/WithBreadcrumb.vue
var t = e;
//#endregion
export { t as default };

//# sourceMappingURL=WithBreadcrumb.vue.js.map